/**
 * O enum que representa os tipos possíveis de classes do personagem
 */
export enum ClassType {
  None = 'none',
  Warrior = 'warrior',
  Archer = 'archer',
  Mage = 'mage',
}
